<template>
	<div>
		<SOLoadingPage v-if="pageSetting.loading"/>

<!--		<div class="vh-100 bg-white p-d-72" v-else>-->
    <div class="vh-100 bg-white" v-else>
      <SOTitleBar
        :page-title="'Status Transaksi'"
        :type="'back'"
        @back="back"
      />

      <div class="content-wrapper customer-content main-page">
        <div class="p-y-20 p-x-20 tl-wrapper">
          <template v-if="idWhitelabel">
            <div v-for="(item, index) in whitelabelStatusList" :key="item.id" class="d-flex align-center" style="gap: 8px">
              <div class="position-relative px-4">
                <div
                    class="p-2 rounded-pill position-absolute z-1"
                    style="top: 30px; transform: translate(-50%, -50%)"
                    :style="`background-color: ${isRedDot(item.status) ? '#F65151' : index == 0 ? '#0052F5' : '#D9D9D9'};`"
                />
                <div
                    class="position-absolute"
                    style="width: 2px; transform: translate(-50%, -0%); background-color: #D9D9D9"
                    :style="index == 0 ? 'top: 30px' : ''"
                    :class="index == whitelabelStatusList.length -1 ? 'h-50' : 'h-100'"
                />
              </div>
              <div class="d-flex justify-content-between flex-grow-1 p-y-10">
                <div class="f-12 flex-grow-1">
                  	<h5 class="f-c-black pb-1 font-weight-normal">
                    	{{ $moment(item.created_at).format("dddd, DD MMM YYYY") }}
					</h5>
					<h5 class="f-c-midgrey font-weight-normal f-12 d-flex">{{ orderStatuses().find(order=> order.value == item.status)?.label ?? '-' }}
						<h3 class="f-bold f-13" v-if="item.status == '81_already_pickup'"><span> : </span>{{ item.transaksi_loyalty.customer.nama }}</h3>
						<h3 class="f-bold f-13" v-if="item.karyawan && item.status != '81_already_pickup'"><span> : </span>{{ item.karyawan.nama }}</h3>
					</h5>
					<div class="f-c-blue f-semi f-12" v-if="item.url" @click="liveTrack(item.url)">
						Klik untuk lihat Live Tracking
					</div>
					<div class="font-weight-normal pt-3" style="gap: 16px" v-if="item.transaksi_foto?.length">
						<div class="f-c-foregroud-3">
							Foto {{ item.transaksi_foto[0]?.keterangan ? '& Keterangan' : ''}}
						</div>
						<div class="d-flex" style="gap: 16px">
							<SOImageList :images="item.transaksi_foto" :title="''"/>
							<div class="f-12 f-c-midgrey">{{ item.transaksi_foto[0]?.keterangan }}</div>
						</div>
					</div>
                </div>
                <h5 class="font-weight-normal f-c-midgrey">
                  {{$moment(item.created_at).format("HH:mm")}} {{ $moment(item.created_at).format("ZZ") == '+0700' ? 'WIB' : $moment(item.created_at).format("ZZ") == '+0800' ? 'WITA' : 'WIT'}}
                </h5>
              </div>
            </div>
          </template>
          <template v-else>
            <div v-for="(std, i) in statusTransaksiReorder" :key="i">
              <SOTransaksiStatusTahapan
                v-if="std.isparent === 0"
                :title="(std.jenis_tahapan === 'pembuatan_transaksi') ? std.title + ' di outlet ' + std.nama_outlet : std.title"
                :sub-title="subtitleFiller(std)"
                :date="(std.jenis_tahapan === 'transaksi_selesai') ? '' : std.waktu"
                :date-raw="std.waktu_raw"
                :images="std.foto_tahapan"
              />

              <SOTransaksiStatusTahapanLayananContainer
                v-if="std.isparent === 1"
                :header="std.title"
                :detail="std.rincian_tahapan_layanan"
                :container-id="i"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOTransaksiStatusTahapan from "@/so-components/modules/transaksi/reguler/status/SOTransaksiStatusTahapan";
import SOTransaksiStatusTahapanLayananContainer
	from "@/so-components/modules/transaksi/reguler/status/SOTransaksiStatusTahapanLayananContainer";
import {orderStatuses} from "../../../../store/utils/vars";
import SOImageList from '@/so-components/global/ui/SOImageList.vue';

export default {
	name: "TransaksiStatus",
  props: {
    idWhitelabel: {
      type: String,
      default: null
    }
  },
	components: {
		SOLoadingPage,
		SOTitleBar,
		SOTransaksiStatusTahapan,
		SOTransaksiStatusTahapanLayananContainer,
		SOImageList,
	},
	computed: {
		...mapGetters("transaksiModule", {
			statusTransaksi: "getStatusTransaksi",
		})
	},
	data() {
		return {
			idtransaksi: "",
			pageSetting: {
				loading: true
			},
			statusTransaksiReorder: [],
      whitelabelStatusList: [],
		}
	},
	mounted() {
		this.idtransaksi = this.$route.params.idtransaksi
		if (this.idWhitelabel) {
			this.getStatusTransaksiWhitelabel();
		} else {
			this.getStatusTransaksi();
		}
		// if (this.idWhitelabel) this.getStatusTransaksiWhitelabel()
		// else this.getStatusTransaksi()
	},
	methods: {
		orderStatuses() {
			return orderStatuses
		},
		back() {
			this.$router.back()
		},
		reorder() {
			for (let i = this.statusTransaksi.data.length - 1; i >= 0; i--) {
				this.statusTransaksiReorder = [...this.statusTransaksiReorder, this.statusTransaksi.data[i]]
			}
		},
		async getStatusTransaksi() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("transaksiModule/fetchStatusTransaksi", this.idtransaksi)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.$router.back()
				return
			}
			this.reorder()
		},
		async getStatusTransaksiWhitelabel() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("transaksiModule/fetchStatusTransaksiWhitelabel", this.idWhitelabel)
			this.whitelabelStatusList = res.data
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				this.$router.back()
			}
		},
		subtitleFiller(std) {
			let subTitle = ""
			switch (std.jenis_tahapan) {
				case "penjadwalan_penjemputan":
					subTitle = "Untuk outlet " + std.nama_outlet
					break;
				case "transaksi_selesai":
					subTitle = "Transaksi sudah selesai, seluruh barang telah diambil/diantarkan ke konsumen."
					break;
				case "transaksi_antar":
					subTitle = ""
					break;
				default:
					subTitle = std.nama_karyawan === "" ? "" : "Oleh " + std.nama_karyawan
					break;
			}
			return subTitle
		},
		liveTrack(url) {
			window.open(url, '_blank')
		},
		isRedDot(status) {
			return ['91_rejeccted', '64_reject_courier_delivery', '71_failed_delivery'].includes(status)
		}
	},
	beforeDestroy() {
		this.$store.commit("transaksiModule/resetStatusTransaksi")
	}
}
</script>